import { SubscriptionForm } from 'components/settings/components/sections/webhooks';

export const SettingsIntegrationsWebhooksEditView = (): JSX.Element => {
  return <SubscriptionForm mode="edit" />;
};
